import type { FormattedStatus, FormattedFinanceStatus } from "components/job/JobTable/types";

const getFinanceLabel = (financeStatus: FormattedFinanceStatus) => {
  if (!financeStatus) return "Updated";
  if (financeStatus === "not_applied") return "Sent";
  if (financeStatus === "finance_not_approved") return "Declined";
  if (
    financeStatus === "under_review" ||
    financeStatus === "applied_for_finance"
  )
    return "Applied";
  if (financeStatus === "finance_deposit_paid" || financeStatus === "financed")
    return "Approved";
  if (financeStatus === "paid") return "Paid";
  return "Updated";
};

export const getLabel = (
  status: FormattedStatus,
  financeStatus: FormattedFinanceStatus
) => {
  if (!status) return "Updated";
  if (status === "draft") return "Created";
  if (status === "sent") return "Sent";
  if (status === "accepted") return getFinanceLabel(financeStatus);
  if (status === "declined") return "Declined";
  if (status === "archived") return "Archived";
  return "Updated";
};
